import { Grid, IconButton, Typography } from "@material-ui/core";
import CustomModal from "shared/components/modal/CustomModal";
import { Condominio } from "./ModalReplicarAcesso";
import { BsArrowLeft } from "react-icons/bs";
import ConfigurarCertificado from "./ConfigurarCertificado";
import { useForm } from "react-hook-form";
import { AiFillQuestionCircle } from "react-icons/ai";
import { useEffect, useState } from "react";
import StandardModalBuscaExternaNf from "shared/components/standardModal/StandardModalBuscaExternaNf";
import stylesModalConfiguracaoBuscaExternaStyles from "./styles/ModalConfiguracaoBuscaExternaStyles";
import { Col } from "react-bootstrap";
import CustomButton from "shared/components/button/CustomButton";
import { possuiMensagemDeErro } from "shared/util/functions/errors/RequestPossuiMensagemDeErro";
import toast from "react-hot-toast";
import { getMensagemDeErroBackend } from "shared/util/functions/errors/GetMensagemDeErroBackend";
import { ConfigurarGroupPayRequest } from "types/request/groupPay/ConfigurarGroupPayRequest";
import { usePostConfigurarGroupPayAsync } from "hooks/groupPay/usePostConfigurarGroupPayAsync";

type ModalConfiguracaoCertificadoProps = {
  openModal: boolean;
  condominioSelecionado: Condominio | null;
  condominiosParaConfigurar: Condominio[];
  loginPrefeitura: string;
  senhaPrefeitura: string;
  setShowModalConfiguracaoCertificado: (value: boolean) => void;
  setCondominioSelecionado: (condominio: Condominio | null) => void;
  setShowModalConfiguracaoBuscaExterna: (value: boolean) => void;
  setShowModalReplicar: (value: boolean) => void;
  setShowModalAcessoVinculado: (value: boolean) => void;
};

type FormData = {
  condominiosIds: number[] | null;
  nomeCertificadoDigital: string | null;
  senhaCertificadoDigital: string | null;
  base64: string | null;
};

const ModalConfiguracaoCertificado = ({
  openModal,
  setShowModalConfiguracaoCertificado,
  condominioSelecionado,
  setCondominioSelecionado,
  condominiosParaConfigurar,
  setShowModalConfiguracaoBuscaExterna,
  setShowModalReplicar,
  setShowModalAcessoVinculado,
  loginPrefeitura,
  senhaPrefeitura
}: ModalConfiguracaoCertificadoProps) => {
  const { control, register, getValues, setValue, handleSubmit, reset, watch } = useForm<FormData>({
    defaultValues: {
      condominiosIds: [],
      nomeCertificadoDigital: "",
      senhaCertificadoDigital: "",
      base64: "",
    },
  });
  const styles = stylesModalConfiguracaoBuscaExternaStyles();
  const { mutateAsync } = usePostConfigurarGroupPayAsync();
  const [showModalAjuda, setShowModalAjuda] = useState<boolean>(false);
  const [condominiosAConfigurar, setCondominiosAConfigurar] = useState<Condominio[]>([]);
  const [indexAtual, setIndexAtual] = useState<number>(0);

  const base64 = watch("base64");
  const senhaCertificadoDigital = watch("senhaCertificadoDigital");
  const isBotaoHabilitado = base64 && senhaCertificadoDigital;

  const condominioAtual = condominiosAConfigurar[indexAtual] || null;
  const totalCondominios = condominiosParaConfigurar.length;

  useEffect(() => {
    if (openModal && condominiosParaConfigurar.length > 0 && condominioSelecionado) {
      if (condominiosAConfigurar.length === 0) {
        const listaOrdenada = [
          condominioSelecionado,
          ...condominiosParaConfigurar.filter(c => c.condominioId !== condominioSelecionado.condominioId)
        ];
        setCondominiosAConfigurar(listaOrdenada);
        setIndexAtual(0);
      }
    } else if (!openModal) {
      setCondominiosAConfigurar([]);
      setIndexAtual(0);
    }
  }, [openModal, condominiosParaConfigurar, condominioSelecionado, condominiosAConfigurar.length]);

  const handleClose = () => {
    setShowModalConfiguracaoCertificado(false);
    setCondominioSelecionado(null);
    setIndexAtual(0);
    setShowModalConfiguracaoCertificado(false);
    reset();
  };

  const handleFecharTodosModais = () => {
    setShowModalConfiguracaoCertificado(false);
    setShowModalConfiguracaoBuscaExterna(false);
    setShowModalReplicar(false);
    setShowModalAcessoVinculado(false);
    reset();
  }

  const handleOpenModalAjuda = () => {
    setShowModalAjuda(true);
  };

  const handleCloseModalAjuda = () => {
    setShowModalAjuda(false);
  };

  const salvarConfiguracao = async () => {
    if (!condominioAtual) return;

    const formValues = getValues();

    const configurarRequest = {
      condominiosIds: [condominioAtual.condominioId],
      loginPrefeitura: loginPrefeitura,
      senhaPrefeitura: senhaPrefeitura,
      nomeCertificadoDigital: formValues.nomeCertificadoDigital,
      senhaCertificadoDigital: formValues.senhaCertificadoDigital,
      certificadoDigitalBase64: formValues.base64,
      permitirBuscaLancamentoNF: true,
    } as ConfigurarGroupPayRequest;

    try {
      await mutateAsync(configurarRequest).then(() => {
        toast.success(
          <div>
            <strong>Condomínio configurado</strong>
            <div>As informações de acesso foram validadas.</div>
          </div>
        );
        handleFecharTodosModais();
      });
    } catch (erro) {
      console.error("Erro ao salvar configuração:", erro);
      if (possuiMensagemDeErro(erro)) {
        toast.error(getMensagemDeErroBackend(erro));
      }
    }
  };

  const salvarEProximo = async () => {
    if (!condominioAtual) return;

    const formValues = getValues();
    const configurarRequest = {
      condominiosIds: [condominioAtual.condominioId],
      loginPrefeitura: loginPrefeitura,
      senhaPrefeitura: senhaPrefeitura,
      nomeCertificadoDigital: formValues.nomeCertificadoDigital,
      senhaCertificadoDigital: formValues.senhaCertificadoDigital,
      certificadoDigitalBase64: formValues.base64,
      permitirBuscaLancamentoNF: true,
    } as ConfigurarGroupPayRequest;

    try {
      await mutateAsync(configurarRequest);

      const proximoIndex = indexAtual + 1;
      if (proximoIndex < condominiosAConfigurar.length) {
        setIndexAtual(proximoIndex);
        reset();
      } else {
        toast.success(
          <div>
            <strong>Condomínio configurado</strong>
            <div>As informações de acesso foram validadas.</div>
          </div>
        );
        handleFecharTodosModais();
      }
    } catch (erro) {
      if (possuiMensagemDeErro(erro)) {
        toast.error(getMensagemDeErroBackend(erro));
      }
    } 
  };

  const Content = () => {
    return (
      <Grid container spacing={1}>
        <div style={{ marginBottom: "0.5rem" }}>
          <IconButton onClick={handleClose} size="small">
            <BsArrowLeft size={25} />
          </IconButton>
        </div>
        <Grid item xs={12}>
          <Typography variant="body1">Configure abaixo a busca do condomínio selecionado.</Typography>
        </Grid>
        <Grid item xs={12} style={{ marginTop: "1rem" }}>
          <Typography variant="body2" style={{ fontWeight: "bold" }}>
            Condomínio: <span>{condominioAtual?.nomeFantasia}</span>
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const FooterConfigurarCertificado = () => {
    const isUltimoCondominio = indexAtual + 1 === totalCondominios;

    return (
      <Grid container style={{ display: "flex", justifyContent: "space-between" }}>
        <Grid item xs={6}>
          <span>
            Configuração {indexAtual + 1} de {totalCondominios}
          </span>
        </Grid>
        <Grid item xs={6}>
          <Col className="d-flex justify-content-end p-0">
            <CustomButton
              id="salvar"
              label={totalCondominios === 1 || isUltimoCondominio ? "Salvar configuração" : "Salvar"}
              onClick={() => salvarConfiguracao()}
              variant="outline-primary"
              className="me-2"
              disabled={!isBotaoHabilitado}
            />
            {(totalCondominios > 1 && !isUltimoCondominio) && (
              <CustomButton
                id="salvarEProximo"
                label="Salvar e configurar próximo"
                onClick={() => handleSubmit(salvarEProximo)()}
                variant="primary"
                className="ps-4 pe-4"
                disabled={!isBotaoHabilitado}
              />
            )}
          </Col>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <CustomModal
        showModal={openModal}
        titulo="Configuração do certificado"
        size="lg"
        onCloseModal={handleClose}
        tipoModal="MODAL_LATERAL"
        scrollable
        hideCloseButton
        customFooter={FooterConfigurarCertificado()}
      >
        <Grid container spacing={2} style={{ marginBottom: "1rem", padding: "0.8rem" }}>
          <Grid item>
            <Content />
          </Grid>
          <Grid item xs={12}>
            <ConfigurarCertificado control={control} register={register} setValue={setValue} customId={"base64"} />
          </Grid>

          <Grid item xs={12} className={styles.containerSessaoDuvida}>
            <AiFillQuestionCircle className={styles.iconeDuvida} />
            <Typography className={styles.textoDuvida}>
              {`Dúvidas sobre como encontrar as informações acima? `}
              <a href="#" className={styles.linkDuvida} onClick={handleOpenModalAjuda}>
                Clique aqui e veja como descobrir.
              </a>
            </Typography>
          </Grid>
        </Grid>
      </CustomModal>
      <StandardModalBuscaExternaNf showModal={showModalAjuda} onCloseModal={handleCloseModalAjuda} />
    </>
  );
};

export default ModalConfiguracaoCertificado;
